module.exports = __webpack_public_path__ + "fonts/Beeline_Sans-Black.68c26113.woff2";